const fromdataedit = [
	{
		inputdata: "",
		title: "上级组织",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "cascader",
		width: "220px",
		options: [],
	  },
	  {
		inputdata: "",
		title: "组织代码",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
	  },
	  {
		inputdata: "",
		title: "组织名称",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
	  },
	  {
		inputdata: 1,
		title: "排序编码",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "numbertowOI",
		width: "210px",
		min: 1,
		max: 5000,
	  },
	  {
		inputdata: "",
		title: "电话 ",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
	  },
	  {
		inputdata: "",
		title: "邮箱",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
	  },
	  {
		inputdata: "",
		title: "备注",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "525px",
	  },
  ]
export default fromdataedit; 

